import { useQuery } from '@tanstack/react-query';
import { customerKeys, getCustomerById } from '../../api/customer';

const CUSTOMER_STALE_TIME_MS = 60_000;

export function useCustomerById(id?: string | number | null) {
  const customerId = Number(id);
  const enabled = Number.isInteger(customerId) && customerId > 0;

  return useQuery({
    queryKey: customerKeys.byId(enabled ? customerId : 0),
    queryFn: () => getCustomerById(customerId),
    enabled,
    staleTime: CUSTOMER_STALE_TIME_MS,
  });
}
